import { Button } from "@/components/rac/button";
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "@/components/radix/dialog";
import { Loader2 } from "lucide-react";

interface ConfirmationDialogProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	onConfirm: () => void;
	onCancel: () => void;
	isLoading: boolean;
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
	open,
	onOpenChange,
	onConfirm,
	onCancel,
	isLoading,
}) => {
	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="sm:max-w-md">
				<DialogHeader>
					<DialogTitle>Search All Properties?</DialogTitle>
					<DialogDescription>
						You haven&apos;t selected a specific location. Would you like to search all properties in Bangalore?
					</DialogDescription>
				</DialogHeader>
				<DialogFooter className="flex flex-col gap-2 sm:flex-row sm:gap-2">
					<Button variant="link" onPress={onCancel} className="w-full sm:w-auto" isDisabled={isLoading}>
						Cancel
					</Button>
					<Button onPress={onConfirm} className="w-full sm:w-auto" isDisabled={isLoading}>
						{isLoading ? (
							<>
								<Loader2 className="w-4 h-4 mr-2 animate-spin" />
								Loading...
							</>
						) : (
							"Search Properties"
						)}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};
